import AddNotesHtml                  from '../invoices/templates/invoice.note.add.html';
import AdviserSearchResultsHtml      from '../../app-lite/advisers/templates/advisers.search.results.html';
import BomActionCellHtml             from '../../app-lite/grids/templates/cell.bom-action.html';
import CurrencyCellHtml              from '../../app-lite/grids/templates/cell.currency.html';
import DynamicColorSelectableRowHtml from '../../app-lite/grids/templates/row.dynamic-color.selectable.html';
import EditableCellHtml              from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml      from '../../app-lite/grids/templates/cell.currency.editable.html';
import EditableNumberCellHtml        from '../../app-lite/grids/templates/cell.number.editable.html';
import InvoiceFooterHtml             from '../invoices/templates/invoice.footer.html';
import NumberCellHtml                from '../../app-lite/grids/templates/cell.number.html';
import ProductInfoHtml               from '../products/templates/product.info.html';
import ProductSearchCellHtml         from '../../app-lite/products/templates/product-search.cell.html';
import UnsortableHeaderCellHtml      from '../../app-lite/grids/templates/cell.unsortable-header.html';

export function DealershipSaleCtrl (
  $filter,
  $uibModal,
  $q,
  $scope,
  $state,
  $translate,
  bigDecimalApi,
  companyApi,
  confirm,
  credits,
  customer,
  Customer,
  dateParsing,
  defaultTaxGroup,
  gridAPI,
  invoice,
  Invoice,
  invoiceApi,
  invoiceTypes,
  messages,
  modalApi,
  paymentMethods,
  payments,
  paymentTerms,
  productApi,
  productSearchApi,
  reorderGrid,
  sessionObjAPI,
  taxGroups,
  vehicleSale,
  vehicleTradeIn,
  workshopAPI
) {
  $scope.loaded = true;

  $scope.invoiceFooterTemplateUrl = InvoiceFooterHtml;

  $scope.company         = sessionObjAPI.company();
  $scope.currency        = sessionObjAPI.currency();
  $scope.editable        = invoice ? invoice.invoice_status === 'O': true;
  $scope.editMode        = false;
  $scope.invoiceTypes    = invoiceTypes;
  $scope.paymentMethods  = paymentMethods;
  $scope.payments        = payments;
  $scope.paymentTerms    = paymentTerms;
  $scope.credits         = credits;
  $scope.session         = sessionObjAPI.base();
  $scope.taxGroups       = taxGroups;
  $scope.vehicleSales    = [];
  $scope.vehicleTradeIns = [];

  $scope.customer = customer || {
    id             : null,
    customer_type  : 'I',
    cash_or_account: 'C',
    price_type     : '1'
  };

  $scope.invoice = invoice || {
    balance_due                 : 0.00,
    cash_or_account             : $scope.customer.cash_or_account || 'C',
    cost                        : 0.00,
    customer_deposits_attributes: [],
    customer_id                 : $scope.customer.id || '',
    depositsToDelete            : [],
    description                 : '',
    discount                    : 0.00,
    discount_type               : 'C',
    freight                     : 0.00,
    gst                         : 0.00,
    id                          : '',
    invoice_items_attributes    : [],
    invoice_number              : '',
    invoice_payment_terms       : $scope.customer.default_payment_terms,
    invoice_status              : 'O',
    invoice_tax_items_attributes: [],
    invoice_type                : 'I',
    itemsToDelete               : [],
    paid                        : 0.00,
    post_date                   : dateParsing.today(),
    rounding                    : '0.00',
    savedBalance                : '0',
    savedTotal                  : '0',
    subtotal                    : 0.00,
    tax_free                    : $scope.customer.tax_free,
    total                       : 0.00,
    work_in_progress            : false
  };

  $scope.originalDiscount = $scope.invoice.discount;

  $scope.Customer = new Customer($scope.customer);
  $scope.Invoice  = new Invoice($scope.invoice);
  $scope.Company  = companyApi;
  var copy        = $scope.Invoice.getCopy();

  $scope.bigDefs = [
    {
      displayName: '',
      enableCellEdit: false,
      cellTemplate: BomActionCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      width: '43px'
    },
    {
      field: 'item_code',
      displayName: $translate.instant('PRODUCT_SPACE.PRODUCT'),
      cellClass: 'Uppercase',
      editableCellTemplate: ProductSearchCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      width: '175px'
    },
    {
      field: 'description',
      displayName: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
      cellClass: 'Capitalize',
      editableCellTemplate: EditableCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      cellEditableCondition: 'editable && row.entity.product_id'
    },
    {
      field: 'unit_price',
      displayName: $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE'),
      min: -99999,
      cellFilter: 'globalCurrency',
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && !editMode && row.entity.product_id',
      width: '120px',
      cellClass: 'align-right',
      editableCellTemplate: EditableCurrencyCellHtml,
      cellTemplate: CurrencyCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml
    },
    {
      field: 'quantity',
      displayName: $translate.instant('PRODUCT_SPACE.QTY'),
      cellClass: 'align-right',
      cellTemplate: NumberCellHtml,
      editableCellTemplate: EditableNumberCellHtml,
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && !editMode && row.entity.product_id && !row.entity.vehicle_sale_id',
      headerCellTemplate: UnsortableHeaderCellHtml,
      width: '61px',
    },
    {
      field: $scope.company.price_includes_tax ? 'cost_including_tax' : 'unit_cost',
      displayName: $translate.instant('JS_SPACE.COLUMNS.UNIT_COST'),
      cellClass: 'align-right ReadOnly',
      cellFilter: 'globalCurrency',
      cellTemplate: CurrencyCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      enableCellEdit: false,
      width: '120px'
    },
    {
      field: 'getTotal()',
      displayName: $translate.instant('INVOICE_SPACE.LINE_TOTAL'),
      cellClass: 'align-right ReadOnly',
      cellFilter: 'globalCurrency',
      cellTemplate: CurrencyCellHtml,
      headerCellTemplate: UnsortableHeaderCellHtml,
      enableCellEdit: false,
      width: '120px'
    }
  ];

  $scope.littleDefs = [
    {
      field: 'item_code',
      displayName: $translate.instant('PRODUCT_SPACE.PRODUCT'),
      cellClass: 'Uppercase',
      enableCellEdit: false,
      width: '175px'
    },
    {
      field: 'description',
      displayName: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
      cellClass: 'Capitalize',
      editableCellTemplate: EditableCellHtml,
      cellEditableCondition: 'editable && row.entity.product_id'
    },
    {
      field: 'unit_price',
      displayName: $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE'),
      min: -99999,
      cellFilter: 'globalCurrency',
      cellEditableCondition: 'editable && !row.entity.is_bom_parent && row.entity.product_id',
      width: '120px',
      cellClass: 'align-right',
      editableCellTemplate: EditableCurrencyCellHtml,
      cellTemplate: CurrencyCellHtml
    },
    {
      field: 'quantity',
      displayName: $translate.instant('PRODUCT_SPACE.QTY'),
      cellClass: 'align-right',
      cellTemplate: NumberCellHtml,
      enableCellEdit: false,
      width: '61px',
    }
  ];

  $scope.grid = {
    cellEditableCondition: 'editable && !editMode',
    columnDefs: parseInt($(window).width()) <= 1200 ? $scope.littleDefs : $scope.bigDefs,
    data: 'invoice.invoice_items_attributes',
    enableCellEditOnFocus: true,
    enableCellSelection: true,
    enableRowSelection: false,
    enableSorting: false,
    multiSelect: false,
    rowHeight: 43,
    rowTemplate: DynamicColorSelectableRowHtml,
    virtualizationThreshold: 9999
  };

  $scope.addDeposit = function (index) {
    return $q.when()
    .then(() => $scope.invoice.id
      ? $q.when()
      : $scope.Invoice.save()
    )
    .then(() => $scope.Invoice.deposit.add(index))
    .then(result => {
      if ( result && result.terminal ) {
        $state.reload();

        return;
      }

      return $scope.Invoice.save();
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.DEPOSIT_ADDED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.addItem = function() {
    $scope.invoice.invoice_items_attributes.push({
      amount       : 0.00,
      description  : '',
      gst          : 0.00,
      gst_free     : false,
      id           : '',
      invoice_id   : '',
      item_code    : '',
      note         : '',
      product_id   : '',
      product_type : 'W',
      quantity     : 0,
      unit_cost    : 0.00,
      unit_price   : 0.00,
      untouched    : true,
    });

    $scope.setFlagsAndFunctions();
  };

  $scope.addNotes = function(row) {
    var modalInstance = $uibModal.open({
      templateUrl: AddNotesHtml,
      resolve: {
        item: function () {
          return row.entity
        },
        editable: function () {
          return $scope.editable
        }
      },
      controller: [ '$scope', '$uibModalInstance', 'item', 'editable', function ($scope, $uibModalInstance, item, editable) {
        $scope.item = item;
        $scope.editable = editable;

        $scope.save = function () {
          $uibModalInstance.close(item);
        };

        $scope.close = function () {
          $uibModalInstance.dismiss(false);
        };
      }]
    });

    modalInstance.result.then(function (item) {
      row = item;
      $scope.Invoice.form.$setDirty();
    });
  };

  $scope.assignVehicle = function (id) {
    workshopAPI.get('/vehicle', id).then(function (data) {
      $scope.vehicle = data;
    }, function (error) {
      messages.error(error);
    });
  };

  $scope.calculateTotals = function () {
    $scope.invoice.subtotal             = $scope.Invoice.totals.subtotal({discount: true});
    $scope.invoice.gst                  = $scope.Invoice.totals.tax();
    $scope.invoice.total                = $scope.Invoice.totals.total();
    $scope.invoice.balance_due          = $scope.Invoice.totals.balance();
    $scope.invoice.rounding             = $scope.Invoice.totals.rounding();
    $scope.invoice.paid                 = $scope.Invoice.totals.paid();
    $scope.invoice.discount_on_subtotal = $scope.Invoice.totals.subtotalDiscount();
    $scope.invoice.discount_total       = $scope.Invoice.totals.totalDiscount();
  };

  $scope.cancelDiscount = function () {
    $scope.invoice.discount = $scope.originalDiscount;

    $scope.toggleDiscount();
  };

  // determines whether or not a invoice line
  // item's quantity can be edited.
  $scope.canEditQuantity = function (entity) {
    if ($scope.editable               &&
      !entity.is_bom_parent           &&
      !$scope.editMode                &&
      entity.product_id               &&
      entity.item_code !== 'TRADE-IN' &&
      entity.item_code !== 'VEHICLE-SALE'
    ) {
      return true;
    }

    return false;
  };

  $scope.confirmDiscount = function () {
    if ( $scope.Invoice.form.discount.$valid ) {
      $scope.originalDiscount = $scope.invoice.discount;

      $scope.calculateTotals();
      $scope.toggleDiscount();
    }
  };

  $scope.copyInvoice = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.COPY_SALE')).then(function () {
      return workshopAPI.get('/invoice/copy_invoice', $scope.invoice.id)
    }).then(function (invoice) {
      sessionObjAPI.setKey('invoice_copy', invoice);

      $state.go('app.invoice', {
        customer_id: invoice.customer_id,
        vehicle_id : invoice.vehicle_id
      });
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.delete = function() {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_SALE'))
      .then(function () {
        workshopAPI.delete('/invoice', $scope.invoice.id)
          .then(function () {
            $scope.Invoice.form.$setPristine();
            $state.go('app');
            messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.DELETED'), 'success');
        }, function (err) {
          messages.error(err);
        });
      });
  };

  /**
   * responsible for emailing invoices, attachments
   * or both. Pops up a lightbox where the user can
   * compose an email and choose attachments if they
   * so choose.
   * @param  {boolean} sendInvoice Sets the default for the
   * send invoice flag. this will default the toggle on the
   * lightbox.
  */
  $scope.email = function (sendInvoice, sendInspection) {
    return $q.when()
    .then(() => $scope.Invoice.form.$dirty || !$scope.invoice.id
      ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_SALE_BEFORE_EMAILING'))
      .then(() => $scope.save({ skipRefresh }))
      : $q.when($scope.invoice)
    ).then(invoice => $scope.Invoice.email(invoice, {
      attachments: $scope.attachments,
      customer   : $scope.customer,
      isSale     : true,
      sendInvoice,
      sendInspection
    }))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  // find the tax group by id.
  $scope.filterTaxGroup = function (id) {
    $scope.invoice.tax_group = $scope.taxGroups.filter(function (group) {
      return group.id === id;
    })[0];
  };

  $scope.followUp = function () {
    modalApi.addNote({
      note: $scope.invoice.follow_up_comment
    }).then(function (note) {
      $scope.invoice.follow_up_comment = note;
    });
  };

  $scope.getVehicleDescription = function ( vehicle = {} ) {
    const buildDate = vehicle.build_date.indexOf('/') >= 0
      ? vehicle.build_date.split('/')[1]
      : vehicle.build_date;

    return `${ buildDate } ${ vehicle.make || '(make unavailable)' } ${ vehicle.model || '(model unavailable)' }`;
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if ($scope.Invoice.closed()) {
      classes.push('readonly');
    }
    else if ($scope.editMode && item.selected) {
      classes.push('selected');
    }
    else if ($scope.editMode && item.active) {
      classes.push('active');
    }
    else if (!$scope.editMode && item.is_bom_parent) {
      classes.push('bom-parent');
    }
    else if (!$scope.editMode && item.bom_parent_id) {
      classes.push('bom-child');
    }

    return classes;
  };

  $scope.getServiceAdviserDetails = function ( id ) {
    return workshopAPI.get('/service_adviser', id);
  };

  // initialize anything and everything.
  $scope.init = function () {
    if ($scope.company.use_multi_tax && $scope.taxGroups.length && !$scope.invoice.tax_group_id) {
      $scope.invoice.tax_group_id = defaultTaxGroup ? defaultTaxGroup.id: ($scope.company.tax_group_id || $scope.taxGroups[0].id);
      $scope.filterTaxGroup($scope.invoice.tax_group_id);
    }
    else if (($scope.company.use_multi_tax || $scope.Invoice.closed()) && $scope.invoice.tax_group_id) {
      $scope.invoice.tax_group = {
        tax_group_items_attributes: $scope.invoice.invoice_tax_items_attributes
      }
    }
    else if (!$scope.company.use_multi_tax) {
      $scope.invoice.tax_group_id = null;
    }

    // if the company uses multi tax, add
    // a tax column to the products grid
    if (!$scope.company.use_multi_tax) {
      $scope.bigDefs.splice($scope.bigDefs.length-1, 0, {
        field: 'getTax()',
        displayName: $scope.currency.tax_name,
        cellFilter: 'globalCurrency',
        cellTemplate: CurrencyCellHtml,
        headerCellTemplate: UnsortableHeaderCellHtml,
        enableCellEdit: false,
        width: '120px',
        cellClass: 'align-right ReadOnly'
      });
    }

    $scope.updateVehicles();

    if (copy) {
      $scope.invoice = copy;
      $scope.filterTaxGroup($scope.invoice.tax_group_id);
    }

    if (invoice || copy) {
      $scope.prepInvoice();
    }
    else {
      $scope.addItem();
    }

    // if a customer is selected and there are
    // no invoice items, launch the vehicle
    // sale modal.
    if ($scope.customer.id
      && $scope.invoice.invoice_items_attributes.length === 1
      && !$scope.invoice.invoice_items_attributes[0].id) {
      $scope.launchUnitSale();
    }

    if ( $scope.invoice.id && $scope.invoice.assigned_service_adviser_id ) {
      $scope.getServiceAdviserDetails($scope.invoice.assigned_service_adviser_id)
      .then( serviceAdviser => {
        $scope.invoice.service_adviser_display_name = serviceAdviser.display_name;

        $scope.serviceAdviserSearch.value = {
          display_name: $scope.invoice.service_adviser_display_name,
          id          : $scope.invoice.assigned_service_adviser_id
        };
      });
    }
  };

  $scope.invoiceAnalysis = function () {
    invoiceApi.viewAnalysis($scope.invoice);
  };

  // launch the appropriate unit action depending
  // on the invoice type.
  $scope.launchUnitAction = function () {
    $scope.Invoice.type('credit') ? $scope.launchUnitCredit() : $scope.launchUnitSale();
  };

  // Launch the process for crediting a previous
  // unit sale.
  $scope.launchUnitCredit = function () {
    $scope.Invoice.launchUnitCreditModal()
      .then(vehicle => {
        const index = $scope.invoice.invoice_items_attributes.at(-1).item_code
          ? $scope.invoice.invoice_items_attributes.length
          : ( $scope.invoice.invoice_items_attributes.length - 1 );

        $scope.productSearch.populate(vehicleSale, { rowIndex: index }, false, { skipAdjustedCost: true })
          .then(() => {
            $scope.invoice.invoice_items_attributes[index].description     = $scope.getVehicleDescription(vehicle);
            $scope.invoice.invoice_items_attributes[index].gst_free        = customer.tax_free;
            $scope.invoice.invoice_items_attributes[index].quantity        = 1;
            $scope.invoice.invoice_items_attributes[index].unit_price      = vehicle.value_of_sale;
            $scope.invoice.invoice_items_attributes[index].untouched       = false;
            $scope.invoice.invoice_items_attributes[index].vehicle_sale_id = vehicle.id;

            $scope.setFlagsAndFunctions();
            $scope.updateVehicles();
            $scope.Invoice.cleanLineItems();
          });
      });
  };

  // Launch the process for a vehicle sale.
  $scope.launchUnitSale = function () {
    $scope.Invoice.launchUnitSaleModal()
      .then(vehicle => {
        const index = $scope.invoice.invoice_items_attributes.at(-1).item_code
          ? $scope.invoice.invoice_items_attributes.length
          : ( $scope.invoice.invoice_items_attributes.length - 1 );

        $scope.productSearch.populate(vehicleSale, { rowIndex: index }, false, { skipAdjustedCost: true })
        .then(() => {
          $scope.invoice.invoice_items_attributes[index].cost_including_tax = vehicle.cost_including_tax;
          $scope.invoice.invoice_items_attributes[index].description        = vehicle.description;
          $scope.invoice.invoice_items_attributes[index].gst_free           = customer.gst_free;
          $scope.invoice.invoice_items_attributes[index].quantity           = 1;
          $scope.invoice.invoice_items_attributes[index].unit_cost          = vehicle.cost;
          $scope.invoice.invoice_items_attributes[index].unit_price         = vehicle.retail_price;
          $scope.invoice.invoice_items_attributes[index].untouched          = false;
          $scope.invoice.invoice_items_attributes[index].vehicle_sale_id    = vehicle.vehicle_sale_id;

          $scope.setFlagsAndFunctions();
          $scope.updateVehicles();
          $scope.Invoice.cleanLineItems();
        });

      });
  };

  // Launch the process for accepting a trade in.
  $scope.launchUnitTradeIn = function () {
    let index = 0;
    let tradeInVehicle;

    $scope.Invoice.launchUnitTradeInModal()
    .then(vehicle => {
      tradeInVehicle = vehicle;

      index = $scope.invoice.invoice_items_attributes.at(-1).item_code
        ? $scope.invoice.invoice_items_attributes.length
        : ( $scope.invoice.invoice_items_attributes.length - 1 );

      return $scope.productSearch.populate(vehicleTradeIn, { rowIndex: index }, false, { skipAdjustedCost: true });
    })
    .then(() => {
      $scope.invoice.invoice_items_attributes[index].description = $scope.getVehicleDescription(tradeInVehicle);
      $scope.invoice.invoice_items_attributes[index].gst_free    = tradeInVehicle.gst_free;
      $scope.invoice.invoice_items_attributes[index].quantity    = 1;
      $scope.invoice.invoice_items_attributes[index].unit_cost   = BigDecimal.ZERO.add(bigDecimalApi.get(tradeInVehicle.value_of_acquisition)).toString();
      $scope.invoice.invoice_items_attributes[index].untouched   = false;

      $scope.invoice.invoice_items_attributes[index].unit_price = $scope.Invoice.type('credit')
        ? Math.abs($scope.invoice.invoice_items_attributes[index].unit_cost).toString()
        : -Math.abs($scope.invoice.invoice_items_attributes[index].unit_cost).toString();

      return $scope.Invoice.save({ skipRefresh: true });
    })
    .then(invoice => {
      $scope.invoice = invoice;

      // Build params for acquisitions call.
      tradeInVehicle.trade_in_invoice_id      = $scope.invoice.id;
      tradeInVehicle.trade_in_invoice_item_id = $scope.invoice.invoice_items_attributes[index].id;

      return workshopAPI.post('/vehicles', tradeInVehicle, 'vehicle');
    })
    .then(vehicle => {
      $scope.invoice.invoice_items_attributes[index].vehicle_trade_in_id = vehicle.id;

      return $scope.Invoice.save({ skipRefresh: true });
    })
    .then(invoice => {
      $scope.invoice = invoice;

      messages.show($translate.instant('DEALERSHIP_SPACE.TRADE_IN_SUCCESSFUL'), 'success');

      $scope.setFlagsAndFunctions();

      $scope.updateVehicles();
    })
    .catch(err => {
      if (index >= 0) {
        $scope.removeItem({
          entity  : $scope.invoice.invoice_items_attributes[index],
          rowIndex: index
        });

        $scope.save({ skipRefresh: true });
      }

      messages.error(err);
    });
  };

  $scope.move = function (direction) {
    $scope.Invoice.form.$setDirty();

    return reorderGrid.moveItem($scope.invoice.invoice_items_attributes, direction);
  };

  $scope.prepInvoice = function () {
    $scope.invoice.customer_deposits_attributes = $scope.invoice.customer_deposits_attributes || [];
    $scope.invoice.depositsToDelete             = [];
    $scope.invoice.discount_type                = $scope.invoice.discount_type || 'C';
    $scope.invoice.itemsToDelete                = [];
    $scope.invoice.paid                         = $scope.Invoice.totals.paid();
    $scope.invoice.tax_free                     = $scope.customer.tax_free;
    $scope.savedBalance                         = $scope.invoice.balance_due;
    $scope.savedTotal                           = $scope.invoice.total;

    $scope.invoice.invoice_items_attributes.length ? $scope.setFlagsAndFunctions() : $scope.addItem();
  };

  $scope.productDetail = function(row) {
    var modalInstance = $uibModal.open({
      templateUrl: ProductInfoHtml,
      windowClass: 'lg-modal',
      resolve: {
        product: function () {
          var id = row.entity.product_id
          return id ? workshopAPI.get('/product', id): '';
        },
        currency: function () {
          return $scope.currency;
        },
        company: function () {
          return $scope.company;
        }
      },
      controller: [ '$scope', '$uibModalInstance', '$translate', 'product', 'currency', 'company', 'Product', function ($scope, $uibModalInstance, $translate, product, currency, company, Product) {
        var productTypes = {
          A: $translate.instant('PRODUCT_TYPES.SUBLET_REPAIR'),
          J: $translate.instant('PRODUCT_TYPES.LABOUR'),
          S: $translate.instant('PRODUCT_TYPES.STOCK'),
          T: $translate.instant('PRODUCT_TYPES.TYRES'),
          W: $translate.instant('PRODUCT_TYPES.CONSUMABLE'),
          X: $translate.instant('PRODUCT_TYPES.ACCESSORIES')
        };

        $scope.product = product;
        $scope.product.retail_price = currency.symbol + $scope.product.retail_price;
        $scope.product.maximum = $scope.product.maximum ? $scope.product.maximum : 0;
        $scope.product.minimum = $scope.product.minimum ? $scope.product.minimum : 0;
        $scope.product.product_type = productTypes[$scope.product.product_type];

        $scope.company = company;

        $scope.qtyAvailable =  productApi.calculateQtyAvailable($scope.product);

        $scope.close = function () {
          $uibModalInstance.dismiss(false);
        };
      }]
    });

    modalInstance.result.then(function (item) {
      row = item;
      $scope.Invoice.form.$setDirty();
    });
  };

  $scope.print = {
    invoice: function() {
      if ($scope.Invoice.form.$dirty || !$scope.invoice.id) {
        confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_SALE_BEFORE_PRINTING'))
          .then($scope.save)
            .then(function (invoice) {
              $scope.Invoice.openReport('jasper_unit_sale', invoice.id);
            }).then(function () {
              return $scope.Invoice.logActivity('invoice');
            }).then(function () {
              $state.reload();
            }, function (err) {
              if (err) {
                messages.error(err);
              }
            });
      }
      else {
        $scope.Invoice.openReport('jasper_unit_sale', invoice.id);
        $scope.Invoice.logActivity('invoice');
      }
    }
  };

  $scope.process = function () {
    if ($scope.invoice.id) {
      $q.when().then(function () {
        return $scope.customer.customer_limited ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.CUSTOMER_ACCOUNT_IS_LIMITED')) : $q.when();
      }).then (function () {
        return $scope.Invoice.save({ skipRefresh: true });
      }).then(function () {
        return $scope.Invoice.process({ isSale: true, skipRefresh: true });
      }).then (function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.SALE'), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
    }
    else {
      $q.when().then(function () {
          return $scope.customer.customer_limited ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.CUSTOMER_ACCOUNT_IS_LIMITED')): $q.when();
      }).then (function () {
          return $scope.Invoice.process({ isSale: true, skipRefresh: true });
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.SALE'), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.productSearch = {
    // The field that indicates and item has already been found
    identifier: 'product_id',
    search: function (typed) {
        return productSearchApi.reservedStockSearch(typed);
    },
    /**
     * Instead of a stream search, there are
     * cases (barcode scan) where we just want
     * a quick find on the code without delaying
     * tab or anything. This is the call for that.
     * @param  {string} typed The entered value to search off of
     * @return {promise}         A promise related to the http call for product
     */
    quickSearch: function (typed) {
      return productSearchApi.quickSearch(typed);
    },
    format: function (product) {
      return angular.isObject(product) ? product.item_code: product;
    },
    getAdjustedCost: function (item, row) {
      productSearchApi.getAdjustedCost('invoice', $scope.customer, item)
      .then(price => {
        // to account for the asynchronous behavior,
        // we need to check if an empty row was removed
        // from the line items.
        if (row.rowIndex === $scope.invoice.invoice_items_attributes.length) {
          row.rowIndex--;
        }

        $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price = price;
      });
    },
    getBomItems: function (item, row) {
      $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price = 0;
      $scope.invoice.invoice_items_attributes[row.rowIndex].is_bom_parent = true;

      var params = [item.id, $scope.customer.id]

      productSearchApi.getBomItems('invoice', item, params)
      .then(boms => {
        Array.prototype.push.apply($scope.invoice.invoice_items_attributes, boms);

        $scope.setFlagsAndFunctions();
      });
    },
    populate (item, row, isNewProduct, options) {
      options = options || {};

      if (row.rowIndex === $scope.invoice.invoice_items_attributes.length) {
        $scope.addItem();
      }

      return productApi.getSalesTaxRate(item)
      .then(taxRate => {

        $scope.invoice.invoice_items_attributes[row.rowIndex].cost_including_tax = item.cost_including_tax;
        $scope.invoice.invoice_items_attributes[row.rowIndex].description        = item.description;
        $scope.invoice.invoice_items_attributes[row.rowIndex].item_code          = item.item_code;
        $scope.invoice.invoice_items_attributes[row.rowIndex].product_id         = item.id;
        $scope.invoice.invoice_items_attributes[row.rowIndex].product_type       = item.product_type;
        $scope.invoice.invoice_items_attributes[row.rowIndex].repco_sku          = item.repco_product_sku;
        $scope.invoice.invoice_items_attributes[row.rowIndex].sales_tax_rate     = taxRate;
        $scope.invoice.invoice_items_attributes[row.rowIndex].unit_cost          = item.cost;

        if (isNewProduct) {
          $scope.invoice.invoice_items_attributes[row.rowIndex].quantity       = 1;
          $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price     = item.retail_price;
          $scope.invoice.invoice_items_attributes[row.rowIndex].update_product = true;

          $scope.setFlagsAndFunctions();
        }
        else {
          $scope.invoice.invoice_items_attributes[row.rowIndex].gst_free      = item.gst_free;
          $scope.invoice.invoice_items_attributes[row.rowIndex].job_card_note = item.job_card_comment;
          $scope.invoice.invoice_items_attributes[row.rowIndex].note          = item.comment;
          $scope.invoice.invoice_items_attributes[row.rowIndex].ordering      = row.rowIndex * 1000000;

          $scope.invoice.invoice_items_attributes[row.rowIndex].quantity = 1;

          if (item.is_bom_parent) {
            this.getBomItems(item, row);
          }
          else if ($scope.customer.id && !options.skipAdjustedCost) {
            this.getAdjustedCost(item, row);
          }
          else {
            $scope.invoice.invoice_items_attributes[row.rowIndex].unit_price = item.retail_price;
          }
        }

        return $q.when(true);
      });
    },
    choose: function (item, row) {
      var self = this;

      $scope.invoice.invoice_items_attributes[row.rowIndex].untouched = false;

      if (item.last) {
        var product = {
          item_code: item.item_code,
          product_type: 'S'
        };

        productSearchApi.advancedSearch(product, row)
        .then(selection => {
          self.populate(selection.selection, row, selection.isNewProduct);
        });
      }
      else {
        self.populate(item, row);
      }
    }
  };

  $scope.refundCredit = function () {
    confirm
      .generic($translate.instant('JS_SPACE.CONFIRM.REFUND_AMOUNT_INVOICE', {
        amount: $filter('currency')($scope.invoice.balance_due, $scope.currency.symbol),
        name: $scope.customer.display_name
      }))
      .then(() => workshopAPI.get('/invoice/process_refund', $scope.invoice.id))
      .then(() => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SALE_REFUNDED'), 'success');
        $state.reload();
      }, err => messages.error(err));
  };

  $scope.removeItem = function (row) {
    // do not allow vehicle sales or
    // trade ins to be deleted this way.
    if (row.entity.item_code !== vehicleSale.item_code && row.entity.item_code !== vehicleTradeIn.item_code) {
      var deletedItem = $scope.invoice.invoice_items_attributes.splice(row.rowIndex, 1);
      var deletedBoms = [];

      if (row.entity.is_bom_parent) {
        for (var i = row.rowIndex; i < $scope.invoice.invoice_items_attributes.length; ++i) {
          var item = $scope.invoice.invoice_items_attributes[i];

          if (item.is_bom_parent) {
            break;
          }
          else if (item.bom_parent_id === row.entity.product_id) {
            item._destroy = '1';
            deletedBoms.push($scope.invoice.invoice_items_attributes.splice(i--, 1)[0]);
          }

        }
      }

      if ($scope.invoice.id && row.entity.id) {
        deletedItem[0]._destroy = '1';
        $scope.invoice.itemsToDelete = $scope.invoice.itemsToDelete.concat(deletedItem);
        $scope.invoice.itemsToDelete = $scope.invoice.itemsToDelete.concat(deletedBoms);
      }

      $scope.updateVehicles();
    }
  };

  // removes a vehicle from the invoice items
  // attributes.
  $scope.removeVehicleFromInvoice = function (vehicle) {
    for (var i=0; i<$scope.invoice.invoice_items_attributes.length; i++) {
      if ($scope.invoice.invoice_items_attributes[i].vehicle_sale_id === vehicle.id) {
        $scope.removeItem({ entity: $scope.invoice.invoice_items_attributes[i], rowIndex: i });
        i = $scope.invoice.invoice_items_attributes.length;
      }
    }
  };

  // removes a vehicle from the specified tracking
  // array.
  $scope.removeVehicleFromTrackingArray = function (array, vehicle) {
    for (var i=0; i<$scope[array].length; i++) {
      if ($scope[array][i].id === vehicle.id) {
        $scope[array].splice(i, 1);
        i = $scope[array].length;
      }
    }
  };

  // handles removing a vehicle from either vehicle
  // sales or vehicle trade ins.
  $scope.removeVehicle = function (array, vehicle) {
    $scope.removeVehicleFromTrackingArray(array, vehicle);
    $scope.removeVehicleFromInvoice(vehicle);
  };

  $scope.save = function (options) {
    options.isSale = true;

    return $scope.Invoice.save(options).then(function (data) {
      $scope.customer.id && $scope.invoice.id ?
        $state.reload() :
        $state.go('app.dealership.sale', {
          customer_id: $scope.customer.id,
          id         : data.id
        });
    });
  };

  // navigate to the sale with the customer
  // id in the url.
  $scope.selectCustomer = function (customer) {
    $scope.customer = customer;

    $scope.invoice.cash_or_account       = customer.cash_or_account || 'C';
    $scope.invoice.customer_id           = customer.id;
    $scope.invoice.invoice_payment_terms = customer.default_payment_terms;
    $scope.invoice.tax_free              = customer.tax_free;

    $scope.save({ skipRefresh: true });
  };

  $scope.serviceAdviserSearch = {
    format: ( adviser = {} ) => adviser.display_name || adviser.service_adviser_display_name,
    list  : [],
    query : ( value ) => workshopAPI.get('/service_advisers/list', [ value, 0, 5 ]),
    select: ( adviser = {} ) => {
      $scope.invoice.assigned_service_adviser_id  = adviser.id;
      $scope.invoice.service_adviser_display_name = adviser.display_name;
    },
    templateUrl: AdviserSearchResultsHtml,
    value      : {
      display_name: $scope.invoice.service_adviser_display_name ? $scope.invoice.service_adviser_display_name : '',
      id          : $scope.invoice.assigned_service_adviser_id
    }
  };

  $scope.setFlagsAndFunctions = function() {
    angular.forEach($scope.invoice.invoice_items_attributes, function (item, idx) {
      item.getTotal = function () {
        return $scope.Invoice.totals.itemTotals.total(item);
      };

      item.getTax = function () {
        return $scope.Invoice.totals.itemTotals.tax(item);
      };

      item.ordering = item.ordering && item.ordering === 0 ? item.ordering: idx * 1000000;
    });
  };

  $scope.submit = function () {
    $q.when().then(function () {
      return $scope.customer.customer_limited ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.CUSTOMER_ACCOUNT_IS_LIMITED')): $q.when();
    }).then (function () {
      return $scope.save({ skipRefresh: true });
    }).then(function (invoice) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SALE'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.toggleDiscount = function () {
    $scope.showDiscount = !$scope.showDiscount;
  };

  $scope.toggleEditMode = function () {
    if ($scope.invoice.invoice_items_attributes[0].ordering === null) {
      reorderGrid.resetIndexes($scope.invoice.invoice_items_attributes);
    }

    $scope.grid.$gridScope.enableCellEditOnFocus = !$scope.grid.$gridScope.enableCellEditOnFocus;
    $scope.grid.selectAll(false);

    $scope.editMode = !$scope.editMode;

    if (!$scope.editMode) {
      $scope.$broadcast('endGridReorder');
    }
  };

  $scope.updateVehicles = function () {
    // filter out any vehicle sales from the
    // invoice items attributes.
    var vehicles = $scope.invoice.invoice_items_attributes.filter(function (item) {
      return item.item_code === vehicleSale.item_code;
    });

    // filter out any vehicle trade ins from
    // the invoice items attributes.
    var tradeIns = $scope.invoice.invoice_items_attributes.filter(function (item) {
      return item.item_code === vehicleTradeIn.item_code;
    });

    // reset the vehicleSales array.
    $scope.vehicleSales = [];

    // reset the vehicleTradeIns array.
    $scope.vehicleTradeIns = [];

    // call to get the vehicle details for
    // each vehicle in the vehicle sales
    // array.
    angular.forEach(vehicles, function (vehicle) {
      workshopAPI.get('/vehicle', vehicle.vehicle_sale_id).then(function (data) {
        $scope.vehicleSales.push(data);
      });
    });

    // call to get the vehicle details for
    // each vehicle in the vehicle trade in
    // array.
    angular.forEach(tradeIns, function (vehicle) {
      workshopAPI.get('/vehicle', vehicle.vehicle_trade_in_id).then(function (data) {
        $scope.vehicleTradeIns.push(data);
      });
    });
  };

  $scope.validateInvoiceType = function () {
    // if the type was changed to credit, launch
    // the unit credit modal.
    if ($scope.Invoice.type('credit')) {
      $scope.launchUnitCredit();
    }
  };

  $scope.void = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.VOID_SALE'))
      .then(function () {
        return $scope.Invoice.void();
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.VOIDED.SALE'), 'success');
        $state.go('app');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.printVehicleForm = function(vehicle) {
    if (!$scope.invoice.id) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_VEHICLE_BEFORE_PRINTING'), 'warning');
      return;
    }

    $scope.Invoice.printVehicleForm(vehicle);
  };

  // $on and $watch functions
  $scope.$on('calculateTotals', $scope.calculateTotals);

  $scope.$watch('invoice.invoice_items_attributes', function (items, oldItems) {
    if (!items.length) {
      $scope.addItem();
    }
    if (items !== oldItems) {
      $scope.$emit('calculateTotals');
    }
  }, true);

  $scope.$watch('invoice.tax_group_id', function (newId, oldId) {
    if ((newId !== oldId) && $scope.company.use_multi_tax) {
      $scope.filterTaxGroup(newId);
      $scope.calculateTotals();
    }
  });

  $(window).resize(function() {
    if (parseInt($(window).width()) <= 1200) {
      $scope.defs = $scope.littleDefs;
    }
    else {
      $scope.defs = $scope.bigDefs;
    }
  });

  $scope.init();
};
